import { ACTIONS } from '../../common/config/config';

const initialState = {
  isAuthenticated: false,
  user: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.USER.LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    case ACTIONS.USER.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    case ACTIONS.USER.ME:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    default:
      return state;
  }
};

export default userReducer;
